<template lang="pug">
VBtn(
  variant="outlined"
  :color="dark ? 'primary-c100' : 'primary-c700'"
  :icon="mdiTranslateVariant"
  title="Language settings"
  aria-label="Language settings"
  @click="openSheet"
)
</template>

<script setup lang="ts">
import { mdiTranslateVariant } from "@mdi/js";
import { useLanguageSheetStore } from "~/stores/useLanguageSheetStore";
import { useDarkMode } from "~/composables/useDarkMode";

const languageSheetStore = useLanguageSheetStore();
const openSheet = () => languageSheetStore.open();
const dark = useDarkMode();
</script>
